import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const ExpressPaymentModal = ({ show, onHide }) => {
    const { t } = useTranslation();
    return (
        <Modal size="lg" className="invoice-modal" show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>{t('Express payment')}</Modal.Title>
                <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onHide} />
            </Modal.Header>
            <Modal.Body>
                <p>
                    {t(
                        `To qualify for Express Payment with Invozio, both you and your customer must have an 'Approved' credit status without remarks as per Invozio's credit policy. We conduct a credit check (UC) on both you and your customer the first time you use Express Payment, and for each new customer thereafter. Additionally, we perform a delivery check with your customer to verify the accuracy of the invoice. This check is initially done and then randomly at various times.`
                    )}
                </p>
                <p>
                    {t(
                        `Payment of your salary is made on the same day once all criteria are met. However, the exact timing of payment depends on how quickly your customer verifies the invoice. If the delivery check is completed before 14:00 on the same day, we aim to pay you the same day or at the latest by the next morning after a weekend or holiday. The cost for Express Payment is 5.9% of the total invoice amount if this fee does not reach 590 SEK, a minimum fee of 590 SEK is charged, compared to the standard 1.9% and the minimum fee of 190 SEK if you wait for your customer to pay the invoice.`
                    )}
                </p>
                <p>
                    {t(
                        "Conditions for 'Approved' status include no payment remarks for both you and the customer, the customer not being yourself or someone with whom you have a significant common interest, workdays not older than 30 days, customer registration with the Swedish Companies Registration Office, customer approval of your created invoice, and no dispute regarding the work performed. By choosing Express Payment, you consent to us conducting a UC check on both you and your customer. Express Payments are not accepted for private individuals and sole proprietorships."
                    )}
                </p>
            </Modal.Body>
        </Modal>
    );
};

export default ExpressPaymentModal;